<template>
  <popup
    :opened="dataToShow"
    @close="changeToShow(false)"
  >
    <!-- BEGIN Content modal move folder -->
    <div v-if="folders.length > 0">
      <div class="my-5 mx-20 lg:my-15 lg:mx-36 2xl:my-18 2xl:mx-28 text-center">
        <h3 class="mb-10">
          Déplacer le {{ filetype }} « {{ filename }} »
        </h3>

        <!-- BEGIN Tree structure -->
        <div
          class="bg-white shadow rounded-xl"
          v-click-outside="resetFolderSelection"
        >
          <div
            id="move_header"
            class="py-6 px-16"
          >
            <div class="relative flex items-center mb-5">
              <div
                v-if="currentFolder != null"
                class="absolute -left-10 cursor-pointer"
                @click="returnBack"
              >
                <icon
                  name="arrow-circle-left"
                  class="text-indigo-600 h-5 w-5"
                />
              </div>
              <h5 class="text-left">
                {{
                  currentFolder !== null
                    ? folders.filter((f) => f.id == currentFolder)[0].name
                    : 'Dépôt de documents'
                }}
              </h5>
            </div>
            <search-bar
              name="searchFolder"
              :has-border="false"
              placeholder="Rechercher un dossier"
              :value="searchFolder"
              :has-suggestion="true"
              @input="
                (newValue) => {
                  searchFolder = newValue;
                }
              "
              @displaySuggestionsList="
                (state) => {
                  displaySuggestionsList(state);
                }
              "
            >
              <template
                v-if="isSuggestionsListDisplayed"
                #suggestionsList
              >
                <div
                  v-for="(folder, kf) in foldersFilter.filter(
                    (f) =>
                      f.id != fileToMove.id &&
                      folders.filter((f2) => f2.folder_id == f.id).length > 0
                  )"
                  :key="kf"
                  class="h-20 cursor-default flex items-center space-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
                  @click.stop="
                    currentFolder = folder.id;
                    isSuggestionsListDisplayed = false;
                  "
                >
                  <icon
                    name="folder"
                    class="h-6 w-7"
                    :class="{
                      'text-indigo-600': folder.color == 'indigo',
                      'text-teal-600': folder.color == 'teal',
                      'text-orange-600': folder.color == 'orange',
                      'text-pink-600': folder.color == 'pink',
                      'text-gray-600': folder.color == 'gray',
                    }"
                  />
                  <p class="text-lg">
                    {{ folder.name }}
                  </p>
                  <p
                    class="text-base font-light italic text-gray-600"
                    v-show="
                      folders.filter((f) => f.folder_id == folder.id).length > 0
                    "
                  >
                    {{ folders.filter((f) => f.folder_id == folder.id).length }}
                    Dossier{{
                      folders.filter((f) => f.folder_id == folder.id).length > 1
                        ? 's'
                        : ''
                    }}
                  </p>
                </div>
              </template>
            </search-bar>
          </div>
          <div class="border-t border-indigo-600" />
          <div id="listFolders">
            <div
              v-if="currentFolder == null && fileToMove.folder_id != null"
              class="grid grid-cols-12 items-center h-20 px-6 hover:bg-indigo-200"
              :class="{
                'bg-gray-200 odd:bg-white bg-opacity-50 odd:bg-opacity-0':
                  selectedFolder != null,
                'bg-indigo-200': selectedFolder == null,
              }"
              @click="
                changeFolder({
                  id: null,
                  name: 'Dépôt de documents',
                })
              "
            >
              <div class="col-span-8 flex text-left items-stretch space-x-3">
                <icon
                  name="folder"
                  class="h-6 w-7 text-gray-600"
                />
                <div class="flex items-center space-x-3">
                  <p class="text-lg">
                    Mon dépôt de documents
                  </p>
                </div>
              </div>
            </div>

            <div
              v-for="(folder, kf) in foldersCanEdit.filter(
                (f) => f.folder_id == currentFolder && f.id != fileToMove.id
              )"
              :key="kf"
              class="group cursor-default"
              :class="{
                'bg-gray-200 odd:bg-white bg-opacity-50 odd:bg-opacity-0':
                  selectedFolder != folder.id,
                'bg-indigo-200': selectedFolder == folder.id,
              }"
              @click.stop="selectedFolder = folder.id"
            >
              <div
                class="grid grid-cols-12 items-center h-20 px-6 hover:bg-indigo-200"
              >
                <div class="col-span-8 flex text-left items-stretch space-x-3">
                  <icon
                    name="folder"
                    class="h-6 w-7"
                    :class="{
                      'text-indigo-600': folder.color == 'indigo',
                      'text-teal-600': folder.color == 'teal',
                      'text-orange-600': folder.color == 'orange',
                      'text-pink-600': folder.color == 'pink',
                      'text-gray-600': folder.color == 'gray',
                    }"
                  />
                  <p class="text-lg max-w-7/12 2xl:max-w-full">
                    {{ folder.name }}
                  </p>
                  <p
                    class="text-base font-light italic text-gray-600 self-center"
                    v-show="
                      folders.filter((f) => f.folder_id == folder.id).length > 0
                    "
                  >
                    {{ folders.filter((f) => f.folder_id == folder.id).length }}
                    Dossier{{
                      folders.filter((f) => f.folder_id == folder.id).length > 1
                        ? 's'
                        : ''
                    }}
                  </p>
                </div>

                <list-avatars
                  class="col-span-3 mb-1/5 left-18"
                  size="w-7 h-7"
                  :list-items="folder.users"
                  libelle-firstname="firstname"
                  libelle-lastname="lastname"
                />

                <div
                  class="col-span-1 cursor-pointer"
                  @click.stop="changeFolder(folder)"
                  v-show="
                    folders.filter((f) => f.folder_id == folder.id).length
                  "
                >
                  <icon
                    name="chevron-right"
                    class="hidden group-hover:block text-pink-600 transform duration-300 hover:scale-125"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Tree structure -->
        <div class="text-red-500 text-sm mt-5">
          <p>{{ ((errors || []).folders || [])[0] }}</p>
        </div>
        <div class="flex justify-center space-x-5 mt-5">
          <action-button
            v-if="saving"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            bg-color-square="bg-gray-600"
            libelle="Déplacer"
            :uppercase="true"
            type-shadow="shadow-gray"
          />
          <action-button
            v-else
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            :libelle="
              'Déplacer' + (selectedFolder == currentFolder ? ' ici' : '')
            "
            :uppercase="true"
            type-shadow="shadow-pink"
            @clickAction="moveFile()"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="my-5 mx-20 lg:my-15 lg:mx-36 2xl:my-18 2xl:mx-28 text-center">
        <h3 class="mb-10 text-pink-600">
          Aucun dossier disponible
        </h3>

        <p>
          Veuillez créer un dossier avant de déplacer le {{ filetype }} « {{ filename }} ».
        </p>
      </div>
    </div>
    <!-- END Content modal add referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ClickOutside from 'vue-click-outside';
import Popup from './../../../components/Popup';
import InputText from './../../../components/Inputs/InputText';
import Icon from './../../../components/Icon';
import ListAvatars from './../../../components/ListAvatars';

import ActionButton from './../../../components/ActionButton';
import SearchBar from './../../../components/Inputs/SearchBar';

export default {
  name: 'MoveFilePopup',

  props: {
    dataToShow: Boolean,
    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
    fileToMove: Object,
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },

  data() {
    return {
      searchFolder: '',
      selectedFolder: null,
      currentFolder: null,
      isSuggestionsListDisplayed: false,
    };
  },

  components: {
    Popup,
    ActionButton,
    InputText,
    Icon,
    SearchBar,
    ListAvatars,
  },

  computed: {
    ...mapGetters({
      folders: 'depotDocuments/folders',
      targetId: 'depotDocuments/targetId',
      auth: 'auth/user',
    }),

    foldersCanEdit: {
      get: function () {
        let idUser = parseInt(this.targetId > 0 ? this.targetId : this.auth.id);

        return [...this.folders].filter(
          (f) =>
            f.author_id == idUser ||
            f.users.filter(
              (u) =>
                u.id == idUser &&
                (u.pivot.role === 'admin' || u.pivot.role === 'edit')
            ).length > 0
        );
      },
    },

    foldersFilter: {
      get: function () {
        return [...this.foldersCanEdit].filter((f) =>
          f.name
            .toLocaleLowerCase()
            .includes(this.searchFolder.toLocaleLowerCase())
        );
      },
    },

    filetype: {
      get: function () {
        return this.fileToMove.type == 'folder' ? 'dossier' : 'fichier';
      },
    },

    filename: {
      get: function () {
        if (this.filetype == 'dossier' && this.fileToMove.name) {
          return this.fileToMove.name;
        }

        return this.fileToMove.name
          ? this.fileToMove.name.substring(
            0,
            this.fileToMove.name.lastIndexOf('.')
          )
          : '';
      },
    },
  },

  methods: {
    changeToShow(val) {
      this.$emit('showChange', val);

      this.searchFolder = '';
      this.selectedFolder = null;
      this.currentFolder = null;
    },

    moveFile() {
      this.searchFolder = '';
      this.$emit(
        'moveFile',
        this.selectedFolder !== null
          ? this.folders.filter((f) => f.id == this.selectedFolder)[0]
          : null
      );
    },

    resetFolderSelection() {
      this.selectedFolder = this.currentFolder;
    },

    changeFolder(folder) {
      this.currentFolder = folder.id;
      this.selectedFolder = this.currentFolder;
    },

    returnBack() {
      this.currentFolder = this.folders.filter(
        (f) => f.id == this.currentFolder
      )[0].folder_id;
      this.selectedFolder = this.currentFolder;
    },

    displaySuggestionsList(state) {
      this.isSuggestionsListDisplayed = state;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
